import { useEffect } from 'react';
import { useLang } from '../../../../../../../../hooks/use-lang';
import { QrTemplateType } from '../../../../../../../../store/api/qr-templates-api';
import { useQrTemplatesStore } from '../../../../../../../../store/use-qr-templates-store';
import { IdValue } from '../../../../../../../../types/props';

export interface QrEditorProps {
  setUploadImage: (data?: File) => void;
  uploadImage?: File;
}

export const useQrEditorSettings = ({ setUploadImage, uploadImage }: QrEditorProps) => {
  const { t } = useLang();

  const { templates, fetchTemplates, handleUpdateTemplate, handleResetTemplate, template } =
    useQrTemplatesStore();

  useEffect(() => {
    fetchTemplates({ is_by_company: true });

    return () => handleResetTemplate();
  }, [fetchTemplates, handleResetTemplate]);

  useEffect(() => {
    if (!uploadImage) return;
    const reader = new FileReader();
    reader.onloadend = () => {
      handleUpdateTemplate({ image: reader.result as string });
    };
    reader.readAsDataURL(uploadImage);

    return () => reader.abort();
  }, [handleUpdateTemplate, uploadImage]);

  const templatesWithNew = [{ id: '', name: t('Новый шаблон') }, ...(templates || [])];

  const handleSelectTemplate = (template: IdValue) => {
    const foundTemplate: Partial<QrTemplateType> | undefined = templatesWithNew.find(
      (item) => item.id === template.id,
    );
    setUploadImage(undefined);
    handleUpdateTemplate({ ...foundTemplate });
  };

  const handleUpdateName = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleUpdateTemplate({ ...template, name: e.currentTarget.value });
  };
  const handleUpload = (file: File[]) => setUploadImage(file[0]);

  return {
    handleUpdateName,
    handleUpload,
    templates: templatesWithNew.map((item) => ({ id: item.id, value: item.name })),
    template,
    handleSelectTemplate,
    t,
  };
};
